import { useState, useEffect, useContext } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { useFormContext } from '../../Context/Context';
import { useReadOnly } from '../../Context/ReadOnlyContext';
import { FinalValuesContext } from '../../Context/FinalValuesContext';
import ConvertTitle from '../ConvertTitle';

const useStarRatingLogic = (id, containerRef, currentPage) => {
  const { drawerData } = useFormContext();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);

  const index = drawerData.findIndex(component => component.id === id);
  const componentState = drawerData[index]?.state || {};

  const [starValue, setStarValue] = useState(componentState.starValue || 'یک عنوان وارد کنید');
  const [subStarValue, setSubStarValue] = useState(componentState.subStarValue || '');
  const [rate, setRate] = useState(componentState.mainRate || 2);
  const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
  const [isHeadingFocused, setHeadingFocused] = useState(false);
  const [condition, setCondition] = useState(false);

  const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith("/card-form/publish") || currentPage.startsWith("/user/fill-form/");

  useEffect(() => {
    drawerData[index].state = {
      ...componentState,
      starValue,
      subStarValue,
      mainRate: rate,
      readOnly
    };
  }, [id, starValue, subStarValue, rate]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setSubHeaderVisible(false);
      setHeadingFocused(false);
    } else {
      setSubHeaderVisible(true);
      setHeadingFocused(true);
    }
  };

  const handleHeadingFocus = (event) => {
    setHeadingFocused(true);
    event.target.select();
  };

  const handleHeadingBlur = () => {
    setHeadingFocused(false);
  };

  useEffect(() => {
    const titleIndex = finalSelectValues.findIndex(item => item.name === "FieldCondition");
    const title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
    const dataIndex = drawerData.findIndex(item => item.title === title);
    const dataCondition = drawerData[dataIndex]?.state.readOnly;

    if (currentPage === '/Publish' && (readOnly || dataCondition) && title === 'StarRating') {
      setCondition(true);
    } else {
      setCondition(false);
    }
  }, [finalSelectValues, readOnly]);

  const theme = useTheme();
  const isUpXxl = useMediaQuery(theme.breakpoints.up('xxs'));
  const SubHeadingInputFontSize = isUpXxl ? '14px' : '12px';
  const HeadingColor = theme.palette.blue[700];

  return {
    starValue,
    subStarValue,
    rate,
    setRate,
    handleStarChange: (e) => setStarValue(e.target.value),
    handleSubStarChange: (e) => setSubStarValue(e.target.value),
    isReadOnly: isReadOnly || condition,
    isSubHeaderVisible,
    isHeadingFocused,
    handleClickOutside,
    handleHeadingFocus,
    handleHeadingBlur,
    SubHeadingInputFontSize,
    HeadingColor
  };
};

export default useStarRatingLogic;
